(() => {
  function init(root = document) {
    root.querySelectorAll('.af-catalog:not([data-af-ready])').forEach(catalog => {
      catalog.dataset.afReady = 'true';
      const controls = catalog.querySelector('.af-family-filters');
      const cards = [...catalog.querySelectorAll('[data-product-family]')];
      if (controls) {
        controls.hidden = false;
        controls.querySelectorAll('button').forEach(button => {
          const family = button.dataset.afFamily;
          if (family !== 'all' && !cards.some(card => card.dataset.productFamily === family)) button.hidden = true;
          button.addEventListener('click', () => {
            controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            let count = 0;
            cards.forEach(card => { card.hidden = family !== 'all' && card.dataset.productFamily !== family; if (!card.hidden) count++; });
            catalog.querySelector('[data-af-count]').textContent = `${count} ${count === 1 ? 'product' : 'products'}`;
          });
        });
      }
      const openGuide = () => { const guide = catalog.querySelector('#how-to-choose'); if (guide && location.hash === '#how-to-choose') guide.open = true; };
      openGuide(); window.addEventListener('hashchange', openGuide);
      catalog.querySelector('a[href="#how-to-choose"]')?.addEventListener('click', () => { catalog.querySelector('#how-to-choose').open = true; });
    });
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
